import { __assign, __rest } from "tslib";
import { DataCapsule } from './data-capsule';
import { CachedStorageStrategy } from './strategies/cached-storage';
import { InMemoryStorageStrategy } from './strategies/in-memory-storage';
import { LocalStorageStrategy, } from './strategies/local-storage';
export function LocalStorageCapsule(options) {
    return new DataCapsule(__assign(__assign({}, options), { strategy: new LocalStorageStrategy() }));
}
export function InMemoryStorageCapsule(options) {
    return new DataCapsule(__assign(__assign({}, options), { strategy: new InMemoryStorageStrategy() }));
}
export function LocalStorageCachedCapsule(_a) {
    var remoteStrategy = _a.remoteStrategy, options = __rest(_a, ["remoteStrategy"]);
    return new DataCapsule(__assign(__assign({}, options), { strategy: new CachedStorageStrategy({
            remoteStrategy: remoteStrategy,
        }) }));
}
//# sourceMappingURL=capsules.js.map